import { Icon } from '@/components/common';
import { TooltipComponent } from '@/components/common/tooltip';
import Icons from '@/const/icons';
import * as React from 'react';

interface ErrorIconProps {
	tooltipText?: string;
	iconSize?: number;
}

export const ErrorIcon: React.FC<ErrorIconProps> = ({
	tooltipText = 'There is an error that needs to be addressed',
	iconSize = 16,
}) => {
	return (
		<TooltipComponent
			label={tooltipText}
			classNameLabel="font-semibold !text-left"
			className="max-w-[184px]"
			trigger={
				<span>
					<Icon src={Icons.danger} width={iconSize} height={iconSize} />
				</span>
			}
		/>
	);
};
